
import IconChevron from '../icons/IconChevron.vue';
export default {
  components: { IconChevron },
  props: {
    label: {
      type: String,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    displayVariable: {
      type: String,
      default: 'text'
    },
    block: Boolean,
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      text: '',
      open: false
    };
  },
  computed: {
    filteredValues () {
      return this.values.filter((value) => {
        return value[this.displayVariable].toLowerCase().includes(this.text.toLowerCase());
      });
    }
  },
  methods: {
    focus () {
      this.text = '';
      this.open = true;
      this.$emit('input', null);
    },
    blur () {
      this.open = false;
      this.$refs.input.blur();
    },
    select (value) {
      this.text = value[this.displayVariable];
      this.$emit('input', value);
      this.blur();
    }
  }
};
